import React, { CSSProperties } from "react";
import { Fieldset } from "shared/ui";
import { AvatarInput } from "shared/ui/avatar-input";
import { api } from "shared/api";

export interface IProfileAvatarForm {
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const ProfileAvatarForm = (props: IProfileAvatarForm) => {
  const profile = api.userProfile.useUserProfileMe();

  const updateAvatar = async (value: string | undefined) => {
    if (!profile.data) return;

    await api.userProfile.userProfileUpdate({ ...profile.data, avatarImageId: value || null });
    await profile.mutate();
  };

  return (
    <form className={props.className} style={props.style} id={props.htmlId}>
      <Fieldset>
        <Fieldset.Content>
          <AvatarInput
            id={profile.data?.id!}
            name={profile.data?.name! || profile.data?.email!}
            value={profile.data?.avatarImage?.id}
            onChange={updateAvatar}
            style={{ float: "right" }}
          />
          <Fieldset.Title>Аватар</Fieldset.Title>
          <Fieldset.Subtitle>
            Нажмите на него, чтобы загрузить файлы.
            <br />
            Также вы можете <a onClick={() => updateAvatar(undefined)}>удалить</a> аватар.
          </Fieldset.Subtitle>
        </Fieldset.Content>
        <Fieldset.Footer>
          <Fieldset.Footer.Status>Аватар опционален, но рекомендуется его установить</Fieldset.Footer.Status>
        </Fieldset.Footer>
      </Fieldset>
    </form>
  );
};

ProfileAvatarForm.defaultProps = {};
